import React, { useState } from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import Line from './line';
import { EvolvingStatement } from '../constants/datagram';
import Sequence, { chosen } from '../constants/sequence';

export interface Props {
  /** The line values array, admits undefined and changing 6 and 9 lines */
  lines: EvolvingStatement;
  /** The datagram name */
  name?: string;
  /** The datagram style */
  style?: StyleProp<ViewStyle>;
  /** An optional identifying number */
  number?: number;
  /** Optionally allow choosing lines values  */
  choosing?: boolean;
  /** Function to call in case of lines chosen */
  onChoose?: () => void;
  /** Optional sequence at the time of choosing lines */
  sequence?: Sequence;
}

type State = {
  complete: boolean;
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
    marginHorizontal: 8,
    alignItems: 'center'
    // minHeight: 190 /* TODO: varía entre tri, hexa, ... */
  },
  textPanel: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: {
    color: '#1f89dc',
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
    flex: 1
  },
  datagram: {
    minWidth: 75,
    maxWidth: 75,
    minHeight: 150 /* TODO: varía entre tri, hexa, ... */,
    maxHeight: 150 /* TODO: varía entre tri, hexa, ... */,
    flexDirection: 'column-reverse'
  }
});

const getNumber = (value: number | undefined) => {
  return value ? `${value}. ` : undefined;
};

const getName = (value: string | undefined) => {
  return value ? `${value}` : undefined;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Datagram = (props: Props, _state: State) => {
  const { lines, name, number, choosing, style } = props; // TODO: lines can determine name and number
  const [collection, setCollection] = useState<EvolvingStatement>(lines);
  // Flex Style reverses instead of lines.reverse()

  const onChoose = (i: number, value: number | undefined): void => {
    const newLines = lines;
    newLines[i] = chosen(value, props.sequence);
    setCollection(newLines);

    if (props.onChoose) props.onChoose();
  };

  const items = collection.map((value, i) => {
    return (
      <Line
        value={value}
        position={i}
        key={i.toString()}
        choosing={choosing}
        onPress={() => {
          if (choosing) onChoose(i, value);
        }}
      />
    );
  });

  const getPanel = () => {
    return number || name ? (
      <View style={styles.textPanel}>
        <Text style={styles.text}>
          {getNumber(number)}
          {getName(name)}
        </Text>
      </View>
    ) : undefined;
  };

  return (
    <View style={[style, styles.container]}>
      {getPanel()}
      <View style={styles.datagram}>{items}</View>
    </View>
  );
};

export default Datagram;
